"use strict";

const _ = require("lodash");
const isServer = require("./is-server")();
const bonusPartTypeName = require("../helpers/get-bonus-part-type-name");

/**
 * Formats response object from API endpoint /v5/story/${storyId}/paid-content/metadata
 *
 * @param {Array<Parts>} parts Parts from the StoryModel
 * @param {DEFAULT_API_RESPONSE} responseMetadata Response object
 * @returns {String|Object} Returns an error, or a result object
 */

const DEFAULT_API_RESPONSE = {
  parts: [],
  story: { price: [] },
  has_full_access: undefined
};

const formatPaidContentMetadata = function(parts, responseMetadata, trans) {
  if (isServer) {
    // We assume the story has confirmed to be paywalled before calling this function
    let storyHasBonusParts = false;
    let atLeastOnePartIsPurchased = false;

    _.each(parts, part => {
      const partMetadata = _.find(responseMetadata.parts, {
        id: part.id.toString()
      });

      part.id = parseInt(part.id, 10);

      part.paywalled = !!partMetadata?.paywalled;
      part.isBlocked = part.paywalled && !partMetadata?.has_access;
      part.blockedMessage = partMetadata?.author_message || "";
      part.isBonusPart = partMetadata?.paid_model === "paid_bonus";
      part.bonusTypeName = bonusPartTypeName(partMetadata?.bonus_type, trans);

      part.bonusPartMetadata = {
        bonusType: partMetadata?.bonus_type,
        authorNote: partMetadata?.author_note,
        chapterDescription: partMetadata?.chapter_description,
        bonusTypeName: part.bonusTypeName
      };

      if (partMetadata) {
        // Could include multiple currencies - default to first
        const priceObj = _.first(partMetadata.price);
        if (priceObj) {
          part.price = priceObj.amount;
        }
      }

      // Process data to set story-level props
      if (!storyHasBonusParts) {
        storyHasBonusParts = part.isBonusPart;
      }

      if (!atLeastOnePartIsPurchased) {
        atLeastOnePartIsPurchased = part.paywalled && !part.isBlocked;
      }
    });

    // Set story-level props in metadata
    responseMetadata.story.hasBonusParts = storyHasBonusParts;

    // We consider paid stories a "preview", so users are
    // aware they will have to pay. Once the user has paid
    // at least once, they know the story isn't free, so
    // it's no longer a preview
    responseMetadata.story.isPaidPreview = !atLeastOnePartIsPurchased;
  }

  return responseMetadata;
};

module.exports = { DEFAULT_API_RESPONSE, formatPaidContentMetadata };
